import { Construction } from '../components/construction';

export const Repertoire: React.FC = () => {
  return <Construction />;
};
